import config from '../config';
import { APIClient } from './APIClient';

//Re-export the errors to make it easy to import
export { RequestError, ServerError, BadRequestError, UnauthorisedError, NotFoundError } from '../errors/API';

class ConfigAPIClient extends APIClient {

    getHeaders () {
        const headers = super.getHeaders();
        const configApiAccessToken = config.get('configApiAccessToken');
        if (configApiAccessToken) {
            return Object.assign(headers, { 'x-access-token': configApiAccessToken });
        }
        return headers;
    }

    makeUrl (path, options = {}) {
        const configApiHost = config.get('configApiHost');
        if (configApiHost) {
            options = Object.assign({}, options, {
                apiHost: configApiHost
            });
        }
        return super.makeUrl(path, options);
    }

}

export default new ConfigAPIClient();
